MOVE.LDP = (function (MOVE) {
    var init = function () {
      var topBrowseCarouselOption = {
        items: 2,
        loop: true,
        showNav: 'show',
        moveBy: 'set',
        margin: 20,
        responsive: {
          0 : {
         items: 2
         },
         600 : {
           items : 3
         },
         996 : {
             items : 4
         },
         1280 : {
             items : 5
         }
        }
      };
      $("#ldp-top-browse-carousel").RdcHorizontalCarousel(topBrowseCarouselOption);
    };
    MOVE.LDP =
    {
        init: init
    };
    return MOVE.LDP;
})(MOVE || {});



// WEBPACK FOOTER //
// ./ldp/common_platform/ldp.js